<template>
    <ul v-if="pager.pages && pager.pages.length" :class="paginateClass">
        <li class="page-item previous" :class="{'disabled': pager.currentPage === 1}" :style="liStyles">
            <a class="page-link" @click="setPage(pager.currentPage - 1)" :style="aStyles"><i class="ti-angle-left"></i></a>
        </li>
        <li v-for="page in pager.pages" :key="page" class="page-item page-number" :class="{'active': pager.currentPage === page}" :style="liStyles">
            <a class="page-link" @click="setPage(page)" :style="aStyles">{{page}}</a>
        </li>
        <li class="page-item next" :class="{'disabled': pager.currentPage === pager.totalPages}" :style="liStyles">
            <a class="page-link" @click="setPage(pager.currentPage + 1)" :style="aStyles"><i class="ti-angle-right"></i></a>
        </li>

    </ul>
</template>

<script>
    import paginate from 'jw-paginate';

    const defaultStyles = {
        ul: {
            margin: 0,
            padding: 0,
            display: 'inline-block'
        },
        li: {
            listStyle: 'none',
            display: 'inline',
            textAlign: 'center'
        },
        a: {
            cursor: 'pointer',
        }
    };

    export default {
        props: {
            dataItems: {
                type: Array,
                required: true
            },
            initialPage: {
                type: Number,
                default: 1
            },
            pageSize: {
                type: Number,
                default: 10
            },
            paginateClass: {
                type: String,
                default: 'pagination'
            },
            maxPages: {
                type: Number,
                default: 10
            },
            disableDefaultStyles: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                pager: {},
                ulStyles: {},
                liStyles: {},
                aStyles: {},
                items: []
            }
        },
        computed:{
            change_dataItems: function () {
                this.items = this.dataItems
                if (this.items && this.items.length) {
                    this.setPage(this.initialPage);
                }
            },
        },
        watch:{
            change_dataItems(nuevo, antiguo){
                this.items = nuevo
                if (this.items && this.items.length) {
                    this.setPage(this.initialPage);
                }
            }
        },

        created () {

            this.items = this.dataItems;
            if (!this.$listeners.changePage) {
                throw 'Missing required event listener: "changePage"';
            }

            // set default styles unless disabled
            if (!this.disableDefaultStyles) {
                this.ulStyles = defaultStyles.ul;
                this.liStyles = defaultStyles.li;
                this.aStyles = defaultStyles.a;
            }

            // merge custom styles with default styles
            if (this.styles) {
                this.ulStyles = { ...this.ulStyles, ...this.styles.ul };
                this.liStyles = { ...this.liStyles, ...this.styles.li };
                this.aStyles = { ...this.aStyles, ...this.styles.a };
            }

            // set page if items array isn't empty
            if (this.items && this.items.length) {
                this.setPage(this.initialPage);
            }

        },
        methods: {
            setPage(page) {
                const { items, pageSize, maxPages } = this;

                // get new pager object for specified page
                const pager = paginate(items.length, page, pageSize, maxPages);

                // get new page of items from items array
                const pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1);

                // update pager
                this.pager = pager;

                // emit change page event to parent component
                this.$emit('changePage', pageOfItems);
            }
        }
    }
</script>
